import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { YellowBrickRoadService } from '../../../../src/app/layouts/application-layout/yellow-brick-road/yellow-brick-road.service';
import { nullSafePath } from '../../shared/helpers/null-safe-path';
import { FeatureFlagService } from '../../shared/services/feature-flag.service';
import { SessionService } from '../../shared/services/session.service';
import { ApplicantService } from '../applicant-service/applicant.service';
import { ResumeParsingStatusModel } from '../applicant-service/service-models/ResumeParsingStatusModel';
import { IterativeApplicationRouterService } from '../iterative-application-router/iterative-application-router.service';
import { JobService } from '../job-service/job.service';
import { JobStatusModel } from '../job-service/models/job-status-model';
import { ProfileModel } from '../job-service/models/profile-model';
import { PersonalInformationViewed } from '../job-service/service-models/PersonalInformationViewed';
import { JobStatusService } from '../job-status.service';

@Component({
  selector: 'app-apply-personal-information',
  templateUrl: './apply-personal-information.component.html',
  styleUrls: ['./apply-personal-information.component.scss']
})
export class ApplyPersonalInformationComponent implements OnInit, OnDestroy {
  @ViewChild('cancelModal')
  cancelModal: ModalDirective;
  @ViewChild(NgForm) profileForm;
  private subscription: Subscription = new Subscription();
  private shouldCollectEEOCForm: boolean;

  processingServerSideRequest = false;
  applicantId: string;
  confirmMobilePhone: string;
  initiallyConfirmedMobilePhone: boolean;
  identifier: string;
  subBrandIdentifier: string;
  jobId: number;
  canNavigateBackwards: boolean;
  provinces = ['AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WV',
    'WI',
    'WY'];
  model: ProfileModel;
  phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  isEmployeeReferral: boolean;
  isExistingEmployee: boolean;
  openSaveAndFinishLaterModal = false;
  saveAndFinishLaterEnabled = false;
  applicantElement = 'Profile';

  constructor(private route: ActivatedRoute,
    private applicantService: ApplicantService,
    private jobService: JobService,
    private jobStatusService: JobStatusService,
    private iterativeApplicationRouterService: IterativeApplicationRouterService,
    private router: Router,
    private ybrService: YellowBrickRoadService,
    private readonly sessionService: SessionService,
    private readonly featureFlagService: FeatureFlagService) {
    this.subscription.add(
      this.ybrService.modelUpdated$.subscribe(
        ybrModel => {
          this.shouldCollectEEOCForm = ybrModel.eeocForm.isIncluded;
        }
      ));

  }

  confirmMobilePhoneIsValid(): boolean {
    return this.model.profile.receiveTexts ? this.model.profile.mobilePhone === this.confirmMobilePhone : true;
  }

  phoneNumberConfirmRequired() {
    return !this.initiallyConfirmedMobilePhone;
  }

  forcePhoneNumberReconfirm() {
    if (!this.model.profile.receiveTexts) {
      this.initiallyConfirmedMobilePhone = false;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    if (this.featureFlagService.flags !== undefined) {
      if (this.featureFlagService.flags['save-and-finish-later'] !== undefined) {
        this.saveAndFinishLaterEnabled = this.featureFlagService.flags['save-and-finish-later'];
      }
    }
    this.featureFlagService.flagChange.subscribe((flags) => {
      this.saveAndFinishLaterEnabled = flags['save-and-finish-later'];
    });

    this.subscription.add(this.route.parent.params.subscribe((params: Params) => {
      this.identifier = params['identifier'];
      this.subBrandIdentifier = params['subBrandIdentifier'];
      this.jobId = params['jobId'];
      this.applicantId = params['applicantId'];

      const event = new PersonalInformationViewed(
        this.jobId,
        new Date(),
        this.sessionService.getSessionId());

      this.subscription.add(this.jobService.trackApplicantEvent(this.jobId, event).subscribe());
    }));

    this.subscription.add(this.route.data
      .subscribe((data: { model: ProfileModel, status: JobStatusModel }) => {
        this.model = data.model;

        if (this.model.profile.employeeReferral) {
          this.isEmployeeReferral = true;
        }

        if (this.model.profile.employeeIdentification) {
          this.isExistingEmployee = true;
        }

        this.jobStatusService.checkIfPageAccessible(data.status, true);
        this.canNavigateBackwards = this.iterativeApplicationRouterService.canNavigateBackwards(
          this.model.yellowBrickRoad.orderableElements,
          0);

        this.initiallyConfirmedMobilePhone =
          this.model.yellowBrickRoad.profilePercentageComplete === 100 && this.model.profile.receiveTexts;
      })
    );

    const context = this;
  }

  onParsingCompleted($event: ResumeParsingStatusModel) {
    if ($event.state === 'Succeeded' && !['Succeeded', 'Failed'].some(x => x === this.model.resumeParsingStatus.state)) {
      this.subscription.add(
        this.jobService.getProfile(this.jobId, +localStorage.getItem('applicationId')).subscribe((model: ProfileModel) => {
          this.model.profile = model.profile;
          this.ybrService.updateIsPartOne(true);
          this.ybrService.updateModel(model.yellowBrickRoad);
        })
      );
    }
  }

  startsWithSearchFn(term: string, item: string) {
    return item.toLowerCase().startsWith(term.toLowerCase());
  }

  openSaveAndFinishLater() {
    this.openSaveAndFinishLaterModal = true;
  }

  saveAndFinishLater(emailAddress: string) {
    if (this.profileForm.form.valid && (!this.phoneNumberConfirmRequired() || this.confirmMobilePhoneIsValid())) {
      this.save(true, emailAddress);
    } else {
      this.partiallySubmitApplication(emailAddress);
    }
  }

  partiallySubmitApplication(emailAddress: string) {
    const shouldTrimSubBrand = this.route.snapshot.params['subBrandIdentifier'] !== undefined ? 3 : 2;
    let routeArray = this.router.url.split('/');
    routeArray = routeArray.splice(shouldTrimSubBrand);
    const route = routeArray.join('/');

    this.subscription.add(this.applicantService.partiallySubmitApplication(emailAddress, route, this.applicantElement)
      .subscribe(
        data => {
          const identifiers = nullSafePath(this.identifier, this.subBrandIdentifier);

          const basePath = [...identifiers, 'jobs', this.jobId, 'apply', this.applicantId];
          this.router.navigate([...basePath, 'finish-later-thank-you']);
          this.processingServerSideRequest = false;
        },
        error => {
          this.processingServerSideRequest = false;
        })
    );
    this.closeSaveAndFinishLater();
  }

  closeSaveAndFinishLater() {
    this.openSaveAndFinishLaterModal = false;
  }

  save(partiallySubmitApplication = false, emailAddress = null) {
    if (this.processingServerSideRequest) {
      return;
    }

    this.processingServerSideRequest = true;

    const applicationId = localStorage.getItem('applicationId');
    if (!this.isEmployeeReferral) {
      this.model.profile.employeeReferral = null;
    }

    if (!this.isExistingEmployee) {
      this.model.profile.employeeIdentification = null;
    }
    
    if (this.model.profile.id === undefined || this.model.profile.id === 0) {
      this.subscription.add(
        this.applicantService.createProfile(applicationId, this.model.profile)
          .subscribe(
            data => {
              if (partiallySubmitApplication) {
                this.partiallySubmitApplication(emailAddress);
              } else {
                this.navigateToNextPage();
                this.processingServerSideRequest = false;
              }
            },
            error => {
              this.processingServerSideRequest = false;
            }));
    } else {
      this.subscription.add(
        this.applicantService.updateProfile(applicationId, this.model.profile)
          .subscribe(
            data => {
              if (partiallySubmitApplication) {
                this.partiallySubmitApplication(emailAddress);
              } else {
                this.navigateToNextPage();
                this.processingServerSideRequest = false;
              }
            },
            error => {
              this.processingServerSideRequest = false;
            }));
    }
  }

  navigateToNextPage() {
    const basePath = nullSafePath(this.identifier, this.subBrandIdentifier, 'jobs', this.jobId, 'apply', this.applicantId);
    if (this.shouldCollectEEOCForm) {
      this.router.navigate([...basePath, 'voluntary-identification']);
    } else {
      this.router.navigate([...basePath, 'review-and-submit']);
    }
  }

  displayCancelModal() {
    this.cancelModal.show();
  }

  cancel() {
    this.router.navigate(nullSafePath(this.identifier, this.subBrandIdentifier));
  }

  unmaskPhoneNumber(val) {
    return val.replace(/\D+/g, '');
  }

  back() {
    this.iterativeApplicationRouterService.back(
      nullSafePath(this.identifier, this.subBrandIdentifier),
      this.model.yellowBrickRoad.orderableElements,
      0,
      this.jobId,
      this.applicantId);
  }
}
